import React from "react";
import {useTranslation} from "react-i18next";

export const AdjustValue: React.FC<{adjust:()=>void}> = ({adjust}) => {
  const { t } = useTranslation();
  return <div style={{padding: "20px 0 10px", verticalAlign: 'center', placeContent: 'space-evenly', fontSize: 10}}>
    <button onClick={adjust} className={'btn'}>{t('calc_for_5')}</button>
  </div>;
}